export const VerificationPath = {
  path: '/verification/:id',
  withId: (id: string): string => {
    return VerificationPath.path.replace(':id', id);
  },
};
